import { useState } from 'react'
import InstagramIcon from '@mui/icons-material/Instagram'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import FacebookIcon from '@mui/icons-material/Facebook'
import {
  Button,
  Container,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

import useSettings from '../../core/useSettings'

export default function AppFooter() {
  const { t, i18n } = useTranslation()
  const { themePreference, setThemePreference } = useSettings()
  const [languageAnchor, setLanguageAnchor] = useState(null)
  const [themeAnchor, setThemeAnchor] = useState(null)
  const currentLanguage = i18n.resolvedLanguage || i18n.language || 'pt'

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{ borderTop: '1px solid', borderColor: 'divider', bgcolor: 'background.paper', mt: 'auto' }}
    >
      <Container maxWidth="lg" sx={{ py: 2 }}>
        <Stack
          direction={{ xs: 'column', lg: 'row' }}
          alignItems={{ xs: 'flex-start', lg: 'center' }}
          justifyContent="space-between"
          spacing={2}
        >
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 0.5, sm: 2 }} color="text.secondary">
            <Typography variant="body2" color="inherit">
              {t('footer.copyright')}
            </Typography>
            <Typography variant="body2" color="inherit">
              {t('footer.built')}
            </Typography>
          </Stack>
          <Stack direction={{ xs: 'column', md: 'row' }} spacing={1.5} alignItems={{ md: 'center' }}>
            <Stack direction="row" spacing={0.5}>
              {[
                ['https://www.linkedin.com/company/clmlserv', <LinkedInIcon fontSize="small" />, 'LinkedIn'],
                ['https://www.instagram.com/clmlserv', <InstagramIcon fontSize="small" />, 'Instagram'],
                ['https://www.facebook.com/clmlserv', <FacebookIcon fontSize="small" />, 'Facebook'],
              ].map(([href, icon, label]) => (
                <IconButton
                  key={label}
                  component="a"
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  size="small"
                  aria-label={label}
                >
                  {icon}
                </IconButton>
              ))}
            </Stack>
            <Button
              variant="outlined"
              size="small"
              endIcon={<KeyboardArrowDownIcon />}
              onClick={(event) => setLanguageAnchor(event.currentTarget)}
            >
              {currentLanguage.toUpperCase()}
            </Button>
            <Menu anchorEl={languageAnchor} open={Boolean(languageAnchor)} onClose={() => setLanguageAnchor(null)}>
              {['pt', 'en'].map((language) => (
                <MenuItem
                  key={language}
                  selected={currentLanguage === language}
                  onClick={() => {
                    i18n.changeLanguage(language)
                    localStorage.setItem('nisform-language', language)
                    setLanguageAnchor(null)
                  }}
                >
                  {language.toUpperCase()}
                </MenuItem>
              ))}
            </Menu>
            <Button
              variant="outlined"
              size="small"
              endIcon={<KeyboardArrowDownIcon />}
              onClick={(event) => setThemeAnchor(event.currentTarget)}
            >
              {t(`footer.theme.${themePreference}`)}
            </Button>
            <Menu anchorEl={themeAnchor} open={Boolean(themeAnchor)} onClose={() => setThemeAnchor(null)}>
              {['system', 'light', 'dark'].map((theme) => (
                <MenuItem
                  key={theme}
                  selected={themePreference === theme}
                  onClick={() => {
                    setThemePreference(theme)
                    setThemeAnchor(null)
                  }}
                >
                  {t(`footer.theme.${theme}`)}
                </MenuItem>
              ))}
            </Menu>
          </Stack>
        </Stack>
      </Container>
    </Container>
  )
}
